import type { QueryClient } from "@tanstack/react-query";

import { getOnboardingDraftStorageKey } from "@/app/onboarding/_lib";
import {
	clearOfflineScoreQueue,
	clearPersistedReactQueryCache,
} from "@/lib/shared/offline";
import { deletePersistedDraft } from "@/lib/shared/persistence/draft-store";

export async function clearClientSessionArtifacts(options: {
	queryClient: QueryClient;
	userId?: string | null;
}) {
	const cleanupTasks: Promise<unknown>[] = [
		clearPersistedReactQueryCache(options.queryClient, options.userId),
		clearOfflineScoreQueue(),
	];

	if (options.userId) {
		cleanupTasks.push(
			deletePersistedDraft(getOnboardingDraftStorageKey(options.userId)),
		);
	}

	await Promise.allSettled(cleanupTasks);
}
